import { render, staticRenderFns } from "./startCheck.vue?vue&type=template&id=0d9d3082&scoped=true&"
import script from "./startCheck.vue?vue&type=script&lang=js&"
export * from "./startCheck.vue?vue&type=script&lang=js&"
import style0 from "./startCheck.vue?vue&type=style&index=0&id=0d9d3082&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9d3082",
  null
  
)

export default component.exports